import React from 'react';
import { useAppSelector } from '../hooks/redux';
import Tabs from '../components/UI/Tabs';
import ProfileHeader from '../components/Profile/ProfileHeader';
import ProfileForm from '../components/Profile/ProfileForm';
import SecuritySection from '../components/Profile/SecuritySection';
import KYCSection from '../components/Profile/KYCSection';

const ProfilePage = () => {
  const { user } = useAppSelector((state) => state.auth);

  const tabs = [
    {
      id: 'profile',
      label: 'Profile',
      content: <ProfileForm />,
    },
    {
      id: 'kyc',
      label: 'KYC Verification',
      content: <KYCSection />,
    },
    {
      id: 'security',
      label: 'Security',
      content: <SecuritySection />,
    },
  ];

  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <ProfileHeader />
      <Tabs tabs={tabs} />
    </div>
  );
};

export default ProfilePage;
